import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography
  } from "@mui/material";
import MDBox from "components/MDBox";
  
import { Formik, Form, Field } from "formik";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ImageUpload } from "store/slice/usersSlice";
import { UpdatePassword } from "store/slice/usersSlice";
import * as Yup from "yup";
  

const ImageUploadModal = ({
    imageModalOpen,
    setImageModalOpen
}) => {
    const [imageFile, setImageFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const dispatch = useDispatch();

    const handleImageSelect = (e) => {
        setImageFile(e.target.files[0]);
    };

    const handleImageSubmit = () => {
        const data = new FormData();
        data.append("image", imageFile);

        dispatch(ImageUpload(data))
        setImageModalOpen(false);
    };
    return (
        <Dialog open={imageModalOpen} onClose={() => setImageModalOpen(false)} fullWidth maxWidth="xs">
            <DialogTitle>Upload Profile Image</DialogTitle>
            <DialogContent style={{textAlign: "center"}}>
                <Typography
                    variant='h5'
                    style={{ marginBottom: 15, marginTop: 0 }}
                >
                    Choose an image
                </Typography>
                <Button variant="contained" component="label">
                    Choose File
                    <input hidden type="file" accept="image/*" onChange={handleImageSelect} />
                </Button>
                {imageFile && (
                    <MDBox mt={2}>
                    <img
                        src={URL.createObjectURL(imageFile)}
                        alt="Preview"
                        style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover" }}
                    />
                    </MDBox>
            )}
            </DialogContent>
            <DialogActions>
            <Button onClick={() => setImageModalOpen(false)}>Cancel</Button>
            <Button onClick={handleImageSubmit} variant="contained" color="primary">
                {uploading ? 'Uploading...' : 'Upload'}
            </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ImageUploadModal;